const isSameOrigin = (url: string | null): boolean => {
  if (!url) {
    return true;
  }

  const stylesheetUrl = new URL(url, window.location.href);
  return stylesheetUrl.origin === window.location.origin;
};

export const extractStylesheetRules = async (
  stylesheet: CSSStyleSheet
): Promise<string> => {
  if (isSameOrigin(stylesheet.href)) {
    try {
      if (stylesheet.cssRules) {
        return Array.from(stylesheet.cssRules).reduce(
          (acc, rule, index) => acc + (index > 0 ? '\n' : '') + rule.cssText,
          ''
        );
      }
    } catch {
      return '';
    }
  }

  if (stylesheet.href) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(stylesheet.href, {
        signal: controller.signal,
      });
      if (response.ok) {
        const css = await response.text();
        // Prevent fetched CSS from breaking out of the injected <style> block
        return css.replace(/<\/style/gi, '<\\/style');
      }
    } catch {
      return '';
    } finally {
      clearTimeout(timeoutId);
    }
  }

  return '';
};

export const getCanvasDataUrl = (
  canvas: HTMLCanvasElement,
  shouldInvert: boolean
): string => {
  if (!shouldInvert) {
    return canvas.toDataURL('image/png');
  }

  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const ctx = tempCanvas.getContext('2d');

  if (!ctx) {
    return canvas.toDataURL('image/png');
  }

  ctx.filter = 'invert(1)';
  ctx.drawImage(canvas, 0, 0);

  return tempCanvas.toDataURL('image/png');
};
